import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Img, Text, Radio } from "components";
import { useTranslation } from "react-i18next";
import SavedAddressesList from "./SavedAddressesList";
import PickUpPointsList from "./PickUpPointsList";
import SendAsAGift from "./SendAsAGift";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { getOrderData, updateOrderData } from "redux/reducers/orderData";
import { AddEditAddress } from "popups/AddEditAddress";
import { getAuth } from "redux/reducers/loginData";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { trackGiftOptionClick } from "utils/helper/custom";

// const Tab = styled.div`
//   /* Add the selected styles when the component is selected */
//   ${({ isSelected }) =>
//     isSelected &&
//     ` 
//   border-color: #BD0043 !important;
// `}
// `;
// const Panal = styled.div`
//   /* Add the selected styles when the component is selected */
//   ${({ isSelected }) =>
//     isSelected &&
//     ` 
//   display: block !important;
// `}
// `;

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "transparent",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 300,
    margin: 0,
    padding: 0,
    ".MuiTooltip-arrow": {
      color: "#FFFFFF", // Arrow color
      width: "28px", // Arrow width
      height: "16px", // Arrow height
      bottom: "-8px", // Position where arrow is pointing
      left: "-9px !important", // Position where arrow is pointing
    },
  },
}));

const DeliveryMode = (props) => {
  const {
    addressList,
    zoneList,
    occasionOptions,
    isEventSent,
    setIsEventSent,
    sendCheckoutGaEvent,
  } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector(getAuth);
  const orderData = useSelector(getOrderData);
  const [activeTab, setActiveTab] = useState(0);
  const { t } = useTranslation();
  const [AddAddressPopup, setAddAddressPopup] = useState(false);

  const handleTabClick = (index) => {
    if (!isEventSent?.beginCheckout) {
      setIsEventSent((prev) => ({ ...prev, beginCheckout: true }));
      sendCheckoutGaEvent("begin_checkout");
    }
    let orderDataDelivery = {
      ...orderData,
      DeliveryModeActiveTab: index,
      delivery_mode: "",
      delivery_type: "",
      deliveryDateTimeActiveTab: 0,
    };
    delete orderDataDelivery?.timeSloat;
    dispatch(
      updateOrderData({
        ...orderData,
        DeliveryModeActiveTab: index,
        delivery_mode: "",
        delivery_type: "",
        deliveryDateTimeActiveTab: 0,
      })
    );
  };
  console.log("orderData--------deliverymode", orderData);
  useEffect(() => {
    setActiveTab(
      orderData?.DeliveryModeActiveTab ? orderData?.DeliveryModeActiveTab : 1
    );
  }, [orderData?.DeliveryModeActiveTab]);

  // useEffect(() => {
  //   if (orderData?.addAddressPopup) {
  //     setAddAddressPopup(true);
  //   }
  // }, [orderData?.addAddressPopup]);

  // useEffect(() => {
  //   if (AddAddressPopup == "getAddressList") {
  //     setAddAddressPopup(false);
  //     dispatch(changeTrigger("loadAddressList"));
  //   } else {
  //     if (!AddAddressPopup) {
  //       dispatch(updateOrderData({ ...orderData, addAddressPopup: false }));
  //     }
  //   }
  // }, [AddAddressPopup]);

  return (
    <>
      <div className="relative flex flex-col w-full">
        {/* After fill Delivery Mode - Completed State */}
        {orderData?.pageStep > 2 ? (
          <>
            <div className="flex flex-col gap-4 items-center justify-start w-full mb-2">
              <div className="flex flex-row xs:flex-col md:gap-5 items-center xs:items-start justify-start w-full">
                <div className="flex flex-col gap-1 items-start justify-start flex-1">
                  <Text className="text-base text-black-900 font-[Unbounded] font-medium">
                    {t("deliveryMode")}:{" "}
                    {(() => {
                      switch (orderData?.delivery_mode) {
                        case "buying_for_love":
                          return t("buyingForALovedOne");
                        case "pickup_point":
                          return t("PickUpPoint");
                        case "home_office":
                          return t("Home");
                        default:
                          return "";
                      }
                    })()}
                  </Text>

                  {orderData?.delivery_mode === "buying_for_love" && (
                    <>
                      <div className="flex gap-1 flex-row items-center">
                        <Text className="text-black-900 text-sm font-nunitoregular">
                          {orderData?.buying_for_love?.recipient_name}
                        </Text>
                      </div>
                      <div className="flex gap-1 flex-row items-center">
                        <Text className="text-black-900 text-sm nunitoregular">
                          {orderData?.buying_for_love?.country_code}{" "}
                          {orderData?.buying_for_love?.mobile_no} |{" "}
                          {orderData?.buying_for_love?.email}
                        </Text>
                      </div>
                    </>
                  )}

                  {orderData?.delivery_mode !== "buying_for_love" && (
                    <>
                      <div className="flex gap-1 flex-row items-center">
                        <Text className="text-black-900 text-sm nunitoregular">
                          {orderData?.delivery_mode === "home_office" ||
                          orderData?.delivery_mode === "pickup_point"
                            ? orderData?.home_office?.address
                            : null}
                        </Text>
                      </div>
                    </>
                  )}
                </div>
                <Button
                  className="w-auto mx-auto px-3 py-1.5 text-sm sm:mx-0"
                  size="sm"
                  variant="OutlineBlack"
                  hover={true}
                  hoverclass="bg-black-900"
                  onClick={(e) => {
                    dispatch(
                      updateOrderData({
                        ...orderData,
                        pageStep: 2,
                        delivery_mode: "",
                        delivery_type: "",
                      })
                    );
                  }}
                >
                  {t("change")}
                </Button>
              </div>
            </div>
          </>
        ) : null}

        {/* Delivery Mode Selection - Active State */}
        {!orderData?.delivery_mode || orderData?.pageStep <= 2 ? (
          <>
            {/* Header */}
            <div className="flex flex-col gap-4 items-center justify-start w-full mt-0.5 mb-4">
              <div className="flex flex-row md:gap-5 items-center justify-start w-full">
                <div className="flex flex-col gap-1 items-start justify-start flex-1">
                  <Text className="text-base text-black-900 font-[Unbounded] font-medium font-[24px]">
                    {t("deliveryInformation")}
                  </Text>
                </div>
              </div>
            </div>

            {/* Modern Tab Design */}
            <div className="w-full mb-6 bg-[white] rounded-xl shadow-sm p-2">
              {/* Tab Headers */}
              <div className="flex gap-2 bg-[#F8F8F8] rounded-full p-1 w-full">
                {/* Delivery Addresses */}
                <button
                  onClick={() => handleTabClick(1)}
                  className={`px-5 py-2 w-[33%] rounded-full text-sm font-medium transition-all
                    ${
                      activeTab === 1
                        ? "bg-[white] text-[#771237] shadow"
                        : "text-gray-500 hover:text-gray-700"
                    }`}
                >
                  {t("deliveryAddresses")}
                </button>

                {/* Pickup Points */}
                <button
                  onClick={() => handleTabClick(2)}
                  className={`px-5 py-2  w-[33%] rounded-full text-sm font-medium transition-all
                    ${
                      activeTab === 2
                        ? "bg-[white] text-[#771237] shadow"
                        : "text-gray-500 hover:text-gray-700"
                    }`}
                >
                  {t("pickupPoints")}
                </button>

                {/* Send Gift */}
                <button
                  onClick={() => handleTabClick(3)}
                  className={`px-5 py-2  w-[33%] rounded-full text-sm font-medium transition-all flex items-center gap-2
                    ${
                      activeTab === 3
                        ? "bg-[white] text-[#771237] shadow"
                        : "text-gray-500 hover:text-gray-700"
                    }`}
                >
                  🎁 {t("sendGift")}
                </button>
              </div>

              {/* Tab Content */}
              <div className="mt-6 bg-white rounded-xl">
                {/* Delivery Addresses Content */}
                {activeTab === 1 && (
                  <div className="w-full">
                    <SavedAddressesList
                      addressList={addressList}
                      setAddAddressPopup={setAddAddressPopup}
                      AddAddressPopup={AddAddressPopup}
                      isEventSent={isEventSent}
                      setIsEventSent={setIsEventSent}
                      sendCheckoutGaEvent={sendCheckoutGaEvent}
                    />
                  </div>
                )}

                {/* Pickup Points Content */}
                {activeTab === 2 && (
                  <div className="w-full">
                    <PickUpPointsList
                      zoneList={zoneList}
                      isEventSent={isEventSent}
                      setIsEventSent={setIsEventSent}
                      sendCheckoutGaEvent={sendCheckoutGaEvent}
                    />
                  </div>
                )}

                {/* Send Gift Content */}
                {activeTab === 3 && (
                  <div className="w-full">
                    <SendAsAGift
                      occasionOptions={occasionOptions}
                      isEventSent={isEventSent}
                      setIsEventSent={setIsEventSent}
                      sendCheckoutGaEvent={sendCheckoutGaEvent}
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        ) : null}

        {/* Add Address Popup - Changed to inline mode */}
        {AddAddressPopup ? (
          <AddEditAddress
            setAddAddressPopup={setAddAddressPopup}
            orderData={orderData}
            pageName={"cart"}
            isInlineMode={true}
          ></AddEditAddress>
        ) : null}
      </div>
    </>
  );
};

export default DeliveryMode;